import e from "./ghl-ui.es1417.js";
import u from "./ghl-ui.es419.js";
function l(r, s, t) {
  var a = s(r);
  return u(r) ? a : e(a, t(r));
}
export {
  l as default
};
